import { Button, Grid, Typography } from '@mui/material'
import React from 'react'


const TopBar = ({ heading }) => {

  const handleLogout = () => {
    localStorage.removeItem('_atk')
    window.location.href = '/'
  }
  return (
    <Grid
      width={'100%'}
      bgcolor={'#111827'}
      display={'flex'}
      p={2}
      justifyContent={'space-between'}
      position={'sticky'}
      top={0}
      alignItems={'center'}
      sx={{
        zIndex: 120,
      }}
    >
      <Grid
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        <img src='/logo.svg' alt='logo' />
        <Typography variant='h6' fontSize={17} color={'#F3F4F6'}>
          Email Spintax Generation Tool
        </Typography>
      </Grid>
      <Grid>
        <Typography
          variant='h2'
          fontWeight={650}
          color='white'
        >
          {heading}
        </Typography>
      </Grid>
      <Grid sx={{ display: 'flex', alignItems: 'center' }}>
        <Button
          sx={{
            backgroundColor: '#F3F4F6',
            color: '#111827',
            textTransform: 'capitalize',
            width: '90px',
            fontWeight: '550',
          }}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Grid>
    </Grid>
  )
}

export default TopBar
